module.exports = __webpack_public_path__ + "img/swiper_img2.fc4f9210.webp";